<template>
  <main class="home">
    <header class="main-header w-100 px-3 mb-0 pb-0 pt-3">
      <Logo class="" />
    </header>
    <hr class="w-100 mx-0 p-0 mb-2" />
    <CreditHelp
      :whatsAppSupportNumber="whatsAppSupportNumber"
      :customerCharterInHelpPage="customerCharterInHelpPage"
      :termsAndConditionsInHelpPage="termsAndConditionsInHelpPage"
      :privacyPolicyInHelpPage="privacyPolicyInHelpPage"
      :supportChatbot="supportChatbot"
      :useFaqSettings="useFaqSettings"
      :faqSettings="faqSettings"
      :countryValues="countryValues"
    />
  </main>
</template>

<script lang="ts" setup>
import CreditHelp from "@/apps/credit-line/components/Help/CreditHelp.vue";
import Logo from "@/apps/credit-line/components/Logo.vue";
import { onMounted, ref } from "vue";
import {
  DEFAULT_SETTING,
  SettingValue,
} from "@/shared-models/consumer/ISetting";
import { SettingsCategory } from "@/shared-models/consumer/SettingsCategory";
import { getSettings } from "@/apps/credit-line/helpers/consumerSettings.helper";
import {
  loadFaqSettings,
  FaqSettings,
  FaqCountryValues,
} from "@/apps/credit-line/helpers/settingsFaq.helper";

const whatsAppSupportNumber = ref<SettingValue>(DEFAULT_SETTING);
const customerCharterInHelpPage = ref<SettingValue>(DEFAULT_SETTING);
const termsAndConditionsInHelpPage = ref<SettingValue>(DEFAULT_SETTING);
const privacyPolicyInHelpPage = ref<SettingValue>(DEFAULT_SETTING);
const supportChatbot = ref<SettingValue>(DEFAULT_SETTING);
const useFaqSettings = ref<boolean>(false);
const faqSettings = ref<FaqSettings | null>(null);
const countryValues = ref<FaqCountryValues | null>(null);

onMounted(async () => {
  try {
    const [helpPageSettings, parsedFaqSettings] = await Promise.all([
      getSettings(SettingsCategory.CL_HELP_PAGE),
      loadFaqSettings(),
    ]);

    whatsAppSupportNumber.value =
      helpPageSettings["whatsAppSupportNumber"] ?? DEFAULT_SETTING;
    customerCharterInHelpPage.value =
      helpPageSettings["customerCharterInHelpPage"] ?? DEFAULT_SETTING;
    termsAndConditionsInHelpPage.value =
      helpPageSettings["termsAndConditionsInHelpPage"] ?? DEFAULT_SETTING;
    privacyPolicyInHelpPage.value =
      helpPageSettings["privacyPolicyInHelpPage"] ?? DEFAULT_SETTING;
    supportChatbot.value =
      helpPageSettings["supportChatbot"] ?? DEFAULT_SETTING;

    // Set FAQ settings if rollout is enabled
    useFaqSettings.value = parsedFaqSettings.enabled;
    faqSettings.value = parsedFaqSettings.faqConfig;
    countryValues.value = parsedFaqSettings.countryValues;
  } catch (error) {
    console.error(error);
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.green {
  color: $pj-color-green;
}
</style>
